import React from 'react';
import styled from '@emotion/styled';
import ReactMarkdown from 'react-markdown';

const Container = styled.div`
  min-height: 100vh;
  background-color: #f5f5f7;
  padding: 2rem;
  display: flex;
  flex-direction: column;
`;

const Content = styled.div`
  max-width: 800px;
  margin: 0 auto;
  background: white;
  padding: 2rem;
  border-radius: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  flex: 1;
`;

const Title = styled.h1`
  color: #1d1d1f;
  margin-bottom: 2rem;
  font-size: 2rem;
  text-align: center;
`;

const MarkdownContainer = styled.section`
  margin-bottom: 2rem;
  h1 {
    color: #1d1d1f;
    margin-bottom:0.5rem;
    font-size: 1.5rem;
  }
  h2 {
    color: #1d1d1f;
    margin-bottom: 0.5rem;
    font-size: 1.0rem;
  }

  p {
    color: #6e6e73;
    line-height: 1.6;
    margin-bottom: 0.5rem;
    font-size: 0.9rem;
  }
`;

const Footer = styled.footer`
  text-align: center;
  padding: 1rem 0;
  color: #86868b;
  font-size: 0.9rem;
`;

function CleanTextAiPrivacyPolicyJa() {
  const currentYear = new Date().getFullYear();
  const markdownContent = `
 # プライバシーポリシー

「宿題スキャナー」（以下「本アプリ」といいます。）は、ユーザーのプライバシーを尊重し、個人情報の保護に最大限の注意を払っております。本アプリではユーザーの個人情報を収集せず、また、ユーザーのデータを保護するための措置を講じております。本プライバシーポリシー（以下「本ポリシー」といいます。）は、本アプリにおける情報の取り扱いについて定めたものです。

## 第1条（個人情報の収集および管理方針）

本アプリでは、ユーザーからの個人情報（氏名、住所、電話番号、メールアドレスなど）を一切収集いたしません。アプリ内のすべての機能は、個人情報の収集を行わないことを前提に設計されています。また、ユーザーのプライバシー保護のため、個人情報保護法に基づき、個人を特定できる情報の収集や保存は一切行いません。

## 第2条（宿題・試験問題の画像およびデータの保存）

本アプリでは、ユーザーが撮影した宿題や試験問題の画像、スキャンした文書、手書き除去処理後のデータはすべてユーザーの端末内に保存され、アプリ外部のサーバー等に保存されることはありません。このため、ユーザーが撮影および保存した画像やデータについては、本アプリおよび開発元では一切アクセスいたしません。また、これらの画像データは第三者に提供されることもなく、ユーザーの端末内で安全に保管されることを保証します。

## 第3条（AI問題解答機能について）

本アプリでは、ユーザーが撮影した問題画像をAIに送信して解答を取得する機能を提供しています。この機能を利用する際、問題画像は一時的に外部のAIサービスに送信されますが、個人を特定できる情報は含まれません。送信された画像は解答処理後に削除され、長期保存されることはありません。また、AIサービスプロバイダーは当該画像を他の目的で使用することはありません。なお、この機能の利用は任意であり、ユーザーはいつでも利用を停止することができます。

## 第4条（カメラおよび写真ライブラリへのアクセス）

本アプリでは、宿題や試験問題の撮影およびスキャン機能を提供するため、ユーザーの端末のカメラおよび写真ライブラリへのアクセス許可を求める場合があります。これらの許可は、アプリの基本機能を実行するためにのみ使用され、許可なくユーザーの写真やカメラ機能にアクセスすることはありません。また、アクセス許可はユーザーがいつでも端末の設定から変更または取り消すことができます。

## 第5条（データの暗号化とセキュリティ）

本アプリでは、ユーザーのデータ保護のため、端末内に保存されるすべてのデータに対して適切な暗号化技術を使用しています。また、アプリの利用中に発生する可能性のあるセキュリティリスクを最小限に抑えるため、定期的なセキュリティアップデートを実施しています。ただし、ユーザーの端末自体のセキュリティについては、ユーザー自身で適切な管理をお願いいたします。

## 第6条（アプリの利用状況分析）

本アプリでは、サービス向上のため、個人を特定できない範囲でアプリの利用状況（機能の使用頻度、エラー発生状況など）を分析する場合があります。これらの分析データには個人情報は含まれず、統計的な情報のみを収集し、アプリの改善および新機能の開発にのみ使用されます。

## 第7条（第三者サービスとの連携）

本アプリでは、AI問題解答機能において第三者のAIサービスを利用しています。これらのサービスプロバイダーは、それぞれ独自のプライバシーポリシーを有しており、ユーザーデータの取り扱いについては各サービスプロバイダーのポリシーに従います。本アプリでは、これらの第三者サービスに送信するデータを最小限に抑え、個人情報が含まれないよう配慮しています。

## 第8条（ユーザー権利とデータ管理）

本アプリは、ユーザーが自己のデータを完全に管理できるよう配慮しています。ユーザーはいつでもアプリ内のデータを削除することが可能であり、本アプリはユーザーの操作がない限りデータを外部に送信することはありません（AI問題解答機能を除く）。また、利用規約に基づき、本アプリの利用に際して個人情報を利用しないため、情報の開示、訂正、削除、利用停止に関するリクエストには該当いたしません。

## 第9条（法的要請への対応）

本アプリでは個人情報を収集していないため、通常の場合において法執行機関等からの情報開示要請に応じることはできません。ただし、法的に有効な令状や裁判所命令等がある場合には、法令に従い適切に対応いたします。

## 第10条（プライバシーポリシーの変更）

本アプリは、本ポリシーの内容を随時見直し、ユーザーのプライバシー保護の向上を図るため、法令の改正やアプリ機能の変更などに応じて本ポリシーを変更することがあります。変更があった場合、最新のプライバシーポリシーを本アプリ内に掲載することによりユーザーへ通知し、掲載と同時に効力を生じるものとします。ユーザーは、定期的に本ポリシーをご確認いただきますようお願いいたします。

## 第11条（お問い合わせ窓口）

本ポリシーに関するお問い合わせやご不明な点については、下記の連絡先までご連絡ください。プライバシーに関するご質問やご懸念がございましたら、お気軽にお問い合わせください。

Eメールアドレス：linappworks@gmail.com

最終更新日：2025年8月20日
  `;

  return (
    <Container>
      <Content>
        <Title>プライバシーポリシー</Title>
        <MarkdownContainer>
          <ReactMarkdown>{markdownContent}</ReactMarkdown>
        </MarkdownContainer>
      </Content>
      <Footer>
        <p>© {currentYear} linappworks. All rights reserved.</p>
        <p>Contact us: linappworks@gmail.com</p>
      </Footer>
    </Container>
  );
}

export default CleanTextAiPrivacyPolicyJa; 